module.exports = __webpack_public_path__ + "img/gc.77d9b47d.png";